import timePickerTemplate from './timePicker.html';
import timePickerController from './TimePicker.controller';

function directive() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      time: '=',
      filterTime: '=',
      disableClear: '=',
      paramName: '@',
      pickerDisabled: '=disabled',
      update: '&'
    },
    template: timePickerTemplate,
    controller: 'TimePickerController'
  };
}

export default function (ngModule) {
  ngModule.directive('timePicker', directive);
  timePickerController(ngModule);
}
